import { useState, useContext } from "react"
import { useNavigate, Link } from "react-router-dom"
import { UserContext } from "../contexts/UserContext"
import { CustomButton } from "../components/global/CustomButton"
import "../styles/signin.css"

export function AdminLogin() {
    const [emailOrPhone, setEmailOrPhone] = useState("")
    const [password, setPassword] = useState("")
    const [adminSecret, setAdminSecret] = useState("")

    const navigate = useNavigate()

    const userDataContext = useContext(UserContext)
    const { dispatch } = userDataContext

    async function handleAdminLogin() {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/signup`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ emailOrPhone, password })
        })
        const json = await response.json()

        if (response.ok) {
            const { user, token } = json
            localStorage.setItem("user2", JSON.stringify({ user, token }))
            dispatch({ type: "LOGIN", payload: { user, token } })
            navigate("/")
        }
    }

    return (
        <div className="signin admin d-flex cntr mx-auto">
            <div className="signin-form p-5 my-3">
                <h3 className="text-center">Exclusive</h3>

                <h2 className="form-title text-center">Log in as admin</h2>

                <div className="d-flex flex-column mb-4">
                    <input
                        type="text"
                        placeholder="Email or Phone number"
                        value={emailOrPhone}
                        onChange={(e) => setEmailOrPhone(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Admin Secret"
                        value={adminSecret}
                        onChange={(e) => setAdminSecret(e.target.value)}
                    />
                </div>

                <div className="d-flex flex-column gap-2">
                    <CustomButton
                        color="primary"
                        text="Log In"
                        btnFunction={handleAdminLogin}
                    />
                </div>

                <div className="mt-5 text-center already-text">
                    Not an admin? <Link to="/adminSignup">Sign up</Link>
                </div>
            </div>

        </div>
    )
}